import { createReportSettings, reports, widgetReport } from 'api/report';
import { actions, types } from 'reducers/dashboard/camera/vehicleMakes';
import { call, put, takeLatest } from 'redux-saga/effects';

function* fetchReport({ requestDate, timezone, period, job }) {
  try {
    const response = yield call(
      widgetReport,
      reports.VEHICLE_TOP_MAKES_WITH_SESSIONS,
      createReportSettings(requestDate, timezone, period, job)
    );

    yield put(actions.reportSuccess(requestDate, timezone, period, response.data));
  } catch (e) {
    yield put(actions.reportFailure(requestDate, timezone, period, e));
  }
}

export default function* vehicleMakes() {
  yield takeLatest(types.REPORT_REQUEST, fetchReport);
}
